import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const qdrant = defineConnector({
  identifier: "qdrant",
  name: "Qdrant",
  tagLine: "Vector search engine",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.cloud.qdrant.io/.*",
  auth: (app) => headerAuth([{ name: "api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Qdrant instance",
      items: [
        {
          kind: "input",
          label: "Instance URL",
          required: true,
          placeholder: "xyz-example.us-east4-0.gcp.cloud.qdrant.io:6333",
          target: { kind: "configuration", field: "domain" },
          helperText: "Include the port if needed (default REST port is 6333).",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Qdrant Cloud dashboard](https://cloud.qdrant.io/), find your API key in the cluster details. See the [docs](https://qdrant.tech/documentation/cloud/authentication/) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/collections`,
  },
});
